import axios from "axios";

export default class ConfigFrService { 
      updateConfiguration = async (id, data) => {
    try {
      const response = axios.put(`${process.env.REACT_APP_API_URL}/config-fr/${id}`, data);
      return response.data;
    } catch (error) {
      throw new Error(
        "Erreur lors de la modification du configuration : " + error.message
      );
    }
  };
    getConfiguration = async (id) => {
    try {
      const response = axios.get(`${process.env.REACT_APP_API_URL}/config-fr/${id}`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors du get de la configuration : " + error.message
      );
    }
  };
}